<template>
  <div class="backgroundSupply">
    <el-card>
      <div class="jump-btn">
        <el-button
          type="primary"
          v-if="this.showingPage === 'fourhundred'"
          @click="jump()"
        >{{$t('lang.btn_backgroundSupply')}}</el-button>
        <el-button
          type="primary"
          v-if="this.showingPage === 'allMaintain'"
          @click="jump()"
        >{{$t('lang.btn_allMaintain')}}</el-button>
        <el-button
          type="primary"
          v-if="this.showingPage === 'maintainInfo'"
          @click="jump()"
        >{{$t('lang.btn_maintainInfo')}}</el-button>
      </div>
      <el-form
        :rules="rules"
        ref="form"
        :model="form"
        class="form"
        :label-width="require('@/config/enum').c_ws6"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-row>
          <el-col :span="5">
           <!-- 请选择小区 其他三个报事 -->
            <el-form-item :label="$t('lang.lab_groundSupplyAddress')" prop="value">
              <el-select v-model="form.value" @change="selectFloor">
                <el-option key :label="$t('lang.lab_selectVillage')" value='' v-if="gardenId === 0"></el-option>
                <el-option
                  v-for="(item,index) in gardens"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 请选择楼号 -->
            <el-form-item prop="floorid">
              <el-select v-model="form.floorid" @change="selectUnit">
                <el-option key :label="$t('lang.lab_floorName')" value></el-option>
                <el-option
                  v-for="(item,index) in floorList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 请选择单元号 -->
            <el-form-item prop="unitid">
              <el-select v-model="form.unitid" @change="selectRoom">
                <el-option key :label="$t('lang.lab_unitName')" value></el-option>
                <el-option
                  v-for="(item,index) in unitList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 请选择房间号 -->
            <el-form-item prop="roomid">
              <el-select v-model="form.roomid">
                <el-option key :label="$t('lang.lab_roomName')" value></el-option>
                <el-option
                  v-for="(item,index) in roomList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <!-- 请选择一级报事 -->
            <el-form-item :label="$t('lang.lab_groundSupplytype')" prop="firstLevelid">
              <el-select v-model="form.firstLevelid" @change="selectSecond">
                <el-option key :label="$t('lang.lab_firstLevel')" value></el-option>
                <el-option
                  v-for="(item,index) in firstLevellist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 请选择二级报事 -->
            <el-form-item prop="secondLevelid">
              <el-select v-model="form.secondLevelid" @change="selectThird">
                <el-option key :label="$t('lang.lab_secondLevel')" value></el-option>
                <el-option
                  v-for="(item,index) in secondLevellist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 请选择三级报事 -->
            <el-form-item prop="thirdLevelid">
              <el-select v-model="form.thirdLevelid" @change="selectFourth">
                <el-option key :label="$t('lang.lab_thirdLevel')" value></el-option>
                <el-option
                  v-for="(item,index) in thirdLevellist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 请选择四级报事 -->
            <el-form-item prop="fourthLevelid">
              <el-select v-model="form.fourthLevelid" @change="selectFifth">
                <el-option key :label="$t('lang.lab_fourthLevel')" value></el-option>
                <el-option
                  v-for="(item,index) in fourthLevellist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 请选择五级报事 -->
            <el-form-item prop="fifthLevelid">
              <el-select v-model="form.fifthLevelid">
                <el-option key :label="$t('lang.lab_fifthLevel')" value></el-option>
                <el-option
                  v-for="(item,index) in fifthLevellist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 是否代报 -->
        <el-form-item
          :label="$t('lang.lab_isValet')"
          prop="isValet"
          v-if="this.showingPage != 'fourhundred'"
        >
          <el-radio v-model="form.isValet" :label="1">{{$t('lang.lab_isYes')}}</el-radio>
          <el-radio v-model="form.isValet" :label="0">{{$t('lang.lab_isNo')}}</el-radio>
        </el-form-item>
          <!-- 是否开启电子签名 -->
        <el-form-item
          :label="$t('lang.lab_isRequireDigitalSignature')"
          prop="isRequireDigitalSignature"
        >
          <el-radio v-model="form.isRequireDigitalSignature" :label="1">{{$t('lang.lab_isYes')}}</el-radio>
          <el-radio v-model="form.isRequireDigitalSignature" :label="0">{{$t('lang.lab_isNo')}}</el-radio>
        </el-form-item>
        <el-form-item
          label="第三方工单"
          prop="IsThirdMaintain"
        >
          <el-radio v-model="form.isThirdMaintain" :label="1">{{$t('lang.lab_isYes')}}</el-radio>
          <el-radio v-model="form.isThirdMaintain" :label="0">{{$t('lang.lab_isNo')}}</el-radio>
        </el-form-item>
        <!-- 补单备注 -->
        <el-form-item
          :label="$t('lang.lab_remarkSupply')"
          prop="remark"
          v-if="this.showingPage != 'fourhundred'"
        >
          <el-input
            maxlength="1000"
            class="input"
            v-model="form.remark"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_remarkSupply')"
          ></el-input>
        </el-form-item>
        <!-- 报事用户 -->
        <el-form-item :label="$t('lang.lab_groundSupplyuser')" prop="user">
          <el-input
            maxlength="30"
            class="input"
            v-model="form.user"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_groundSupplyuser')"
          ></el-input>
        </el-form-item>
        <!-- 报事电话 -->
        <el-form-item :label="$t('lang.lab_groundSupplyphone')" prop="tele">
          <el-input
            @input="keyBA"
            maxlength="11"
            class="input"
            v-model="form.tele"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_groundSupplyphone')"
          ></el-input>
        </el-form-item>
        <!-- 事件性质 -->
        <el-form-item
          :label="$t('lang.lab_groundSupplynature')"
          prop="nature"
          v-if="this.showingPage === 'fourhundred'"
        >
          <el-select
            v-model="form.nature"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_groundSupplynature')"
          >
            <el-option key :label="$t('lang.lab_complainFlag')" value></el-option>
            <el-option
              v-for="(item,index) in natures"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 类别 -->
        <el-form-item
          :label="$t('lang.lab_groundtype')"
          prop="searchUnit"
          v-if="(form.nature ==='2'||form.nature ==='3') && this.showingPage === 'fourhundred'"
        >
          <el-select class="select" v-model="form.searchUnit" multiple filterable collapse-tags>
            <el-option
              v-for="(item,index) in form.group"
              :key="index"
              :label="item.code"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 报事内容 -->
        <el-form-item :label="$t('lang.lab_groundSupplycontext')" prop="context">
          <el-input
            maxlength="1000"
            class="input"
            type="textarea"
            rows="5"
            v-model="form.context"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_groundSupplycontext')"
          ></el-input>
        </el-form-item>
        <!-- 巡检标准 -->
        <el-form-item
          :label="$t('lang.lab_inspectionStandard')"
          v-if="this.showingPage != 'fourhundred'"
        >
          <el-button @click="selectPatrolStandard()">{{$t('lang.lab_inspectionStandard')}}</el-button>
        </el-form-item>
        <!-- 巡检设备 -->
        <el-form-item
          :label="$t('lang.lab_inspectionDevice')"
          v-if="this.showingPage != 'fourhundred'"
        >
          <el-button @click="selectPatrolDevice()">{{$t('lang.lab_inspectionDevice')}}</el-button>
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files" ref="files">
          <upload-morefile ref="uploading" :accept='accept'  upTypes='1'  :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-morefile>
        </el-form-item>
        <!-- 上传附件 -->
        <el-form-item :label="$t('lang.lab_accessories')" prop="withFiles" ref="withFiles">
          <upload-morefile ref="uploading"  upTypes='0'  :clears='clears' @outputFile="getFilefj" @removeFile='removeFilefj'></upload-morefile>
       </el-form-item>
        <!-- 责任人 -->
        <el-form-item :label="$t('lang.lab_groundSupplyreceivePerson')" prop="chargePerson">
          <el-select
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_groundSupplyreceivePerson')"
            filterable
            clearable
            class="selectPerson"
            v-model="form.chargePerson"
            collapse-tags
          >
            <el-option
              v-for="(item,index) in chargePersons"
              :key="index"
              :value="item.id"
              :label="item.idNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 抄送人 -->
        <el-form-item :label="$t('lang.lab_groundSupplycopyPerson')" prop="copyPerson">
          <el-select
            multiple
            collapse-tags
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_groundSupplycopyPerson')"
            filterable
            class="selectPerson"
            v-model="form.copyPerson"
          >
            <el-option
              v-for="(item,index) in copyPersons"
              :key="index"
              :value="item.id"
              :label="item.idNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 封单人 -->
        <el-form-item label="封单人" prop="endPerson">
          <el-select
            placeholder="请选择封单人"
            filterable
            clearable
            class="selectPerson"
            v-model="form.endPerson"
            collapse-tags
          >
            <el-option
              v-for="(item,index) in endPersons"
              :key="index"
              :value="item.id"
              :label="item.idNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="网页链接"
          prop="linkUrl"
        >
        <div style="display:flex;">
          <el-input
            maxlength="1000"
            class="input"
            v-model="form.linkUrl"
            placeholder="请输入网页链接"
          ></el-input>
          <el-tooltip class="item" effect="light" content="该链接可填入需要展示的网页链接，在查看工单时可直接跳转查看" placement="right">
              <el-button class="noStyle"><i class="el-icon-warning-outline tipIcon"></i></el-button>
            </el-tooltip>
        </div>
          
        </el-form-item>
      </el-form>
      <!-- 巡检标准/设备列表 弹框 -->
      <el-dialog
        :visible.sync="isShow"
        :close-on-click-modal="false"
        center
        top="130px"
        width="600px"
        :title="title"
        @closed="handleDialogClosed"
      >
        <!-- 巡检标准预览 弹框 -->
        <el-dialog
          :visible.sync="isPreview"
          center
          top="130px"
          width="600px"
          :title="titlePreview"
          append-to-body
        >
          <el-form
            ref="formPreview"
            :model="formPreview"
            class="form"
            :label-width="require('@/config/enum').c_ws4"
            :label-suffix="require('@/config/enum').c_colon"
          >
            <el-form-item :label="$t('lang.lab_standardName')">
              <el-input
                v-model="formPreview.name"
                :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_standardName')"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_standardMethod')">
              <el-input
                type="textarea"
                :autosize="{ minRows: 1, maxRows: 5}"
                :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_standardMethod')"
                v-model="formPreview.info"
                maxlength="1000"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_standardImg')">
              <viewer :images="formPreview.urls">
                <img v-for="(src,index) in formPreview.urls" :src="src" :key="index" class="img" />
              </viewer>
            </el-form-item>
          </el-form>
        </el-dialog>
        <el-scrollbar>
          <el-form v-if="this.title === this.$i18n.t('lang.lab_inspectionStandardList')" class="trees">
            <!-- 添加搜索输入框 -->
            <el-input v-model="patrolSearchText" placeholder="请输入巡检标准名称" prefix-icon="el-icon-search" style="margin-bottom: 15px;" clearable @clear="patrolSearchText = ''"></el-input>
            <el-checkbox-group v-model="patrolStandard" class="checkbox-line">
              <el-checkbox
                v-for="(item,index) in filteredPatrolStandards"
                :key="index"
                :label="item.id"
                :value="item.id"
              >
                <el-button type="text" @click="previewPatrolStandard(item.id)">{{item.name}}</el-button>
              </el-checkbox>
            </el-checkbox-group>
          </el-form>
          <el-form v-if="this.title === this.$i18n.t('lang.lab_inspectionDeviceList')" class="trees">
            <!-- 添加搜索输入框 -->
            <el-input v-model="deviceSearchText" placeholder="请输入巡检设备名称" prefix-icon="el-icon-search" style="margin-bottom: 15px;" clearable @clear="deviceSearchText = ''"></el-input>
            <el-checkbox-group v-model="device" class="checkbox-line">
              <el-checkbox
                v-for="(item,index) in filteredPatrolDevices"
                :key="index"
                :label="item.id"
                :value="item.id"
                class="option-text"
              >
                <span class="option-color">{{item.name}}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-form>
        </el-scrollbar>
      </el-dialog>
      <el-button class="btn-first" @click="res('form')">{{$t('lang.btn_rest')}}</el-button>
      <el-button
        :disabled="isDisabled"
        class="detailbtn"
        type="primary"
        @click="onSubmit('form')"
      >{{$t('lang.btn_save')}}</el-button>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:backgroundSupply
 *@Description:400后台补单
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-03-17
 */
/**
 *@ClassName:backgroundSupply
 *@Description:全项目后台补单 报事信息后台补单 全项目自动巡检后台补单
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-21
 */
import uploadmoreFile from './upload_morefile.vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    var isPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系人电话'))
      } else {
        let regPone = null
        let mobile = /^1(3|4|5|6|7|8|9)\d{9}$/
        // eslint-disable-next-line no-useless-escape
        let tel = /^(0[0-9]{2,3})([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/
        if (String(value).charAt(0) == 0) {
          regPone = tel
        } else {
          regPone = mobile
        }
        if (!regPone.test(value)) {
          return callback(new Error("请填写联系人电话(座机格式'区号座机号码')"))
        }
        callback()
        }
    }
    var valligeCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_chooseGarden')))
      } else {
        callback()
      }
    }
    var floorCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_selectHouse')))
      } else {
        callback()
      }
    }
    var unitCheck = (rule, value, callback) => {
      if (value === '') {
       callback(new Error(this.$i18n.t('lang.lab_selectUnit')))
      } else {
        callback()
      }
    }
    var roomCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_selectRoom')))
      } else {
        callback()
      }
    }
    var firstLevelCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_firstLevel')))
      } else {
        callback()
      }
    }
    return {
      clears: false, // 清空按钮
      accept: '.jpg, .jpeg, .png',
      id: '', // 判断新增还是修改
      isDisabled: false, // 确定按钮置灰
      fileListfj: [], // 附件上传
      fileList: [], // 图片上传
      gardens: [], // 小区下拉列表
      floorList: [], // 楼层下拉列表
      unitList: [], // 单元下拉列表
      roomList: [], // 房间下拉列表
      type: 1, // 楼号单元号房间号区分
      firstLevellist: [], // 一级分类list
      secondLevellist: [], // 二级分类list
      thirdLevellist: [], // 三级分类list
      fourthLevellist: [], // 四级分类list
      fifthLevellist: [], // 五级分类list
      typeleval: 1, // 级别接口区分字段
      isShow: false, // 弹框开关
      isPreview: false, // 预览开关
      title: '', // title
      titlePreview: '', // 预览title
      patrolStandard: [], // 巡检标准绑定数组
      patrolStandardList: [], // 巡检标准列表
      device: [], // 巡检设备绑定数组
      patrolDeviceList: [], // 巡检设备列表
      formPreview: [], // 巡检设备列表
      rules: {
        user: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_paperusername'),
            trigger: 'blur'
          }
        ],
        tele: [{ required: true, validator: isPhone, trigger: 'blur' }],
        nature: [
          {
            required: true,
            message: this.$i18n.t('lang.lab_complainFlag'),
            trigger: 'change'
          }
        ],
        context: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_groundSupplycontext'),
            trigger: 'blur'
          }
        ],
        value: [
          {
            required: true,
            validator: valligeCheck,
            trigger: 'change'
          }
        ],
        floorid: [
          {
            required: true,
            validator: floorCheck,
            trigger: 'change'
          }
        ],
        unitid: [
          {
            required: true,
            validator: unitCheck,
            trigger: 'change'
          }
        ],
        roomid: [
          {
            required: true,
            validator: roomCheck,
            trigger: 'change'
          }
        ],
        firstLevelid: [
          {
            required: true,
            validator: firstLevelCheck,
            trigger: 'change'
          }
        ],
      },
      form: {
        tele: '',
        context: '',
        user: '',
        nature: '',
        files: '',
        value: '',
        floorid: '',
        unitid: '',
        roomid: '',
        firstLevelid: '',
        secondLevelid: '',
        thirdLevelid: '',
        fourthLevelid: '',
        fifthLevelid: '',
        searchUnit: [],
        copyPerson: [],
        chargePerson: '',
        endPerson: '',
        linkUrl: '',
        isValet: '', // 是否代客报事
        isRequireDigitalSignature: 0, // 是否开启电子签名
        isThirdMaintain: 0,
        remark: '' // 补单备注
      }, // 对象
      chargePersons: [], // 责任人list
      copyPersons: [], // 抄送人list
      endPersons: [], // 封单人list
      fileslist: [], // 图片list
      withFileslist: [], // 附件list
      parentId: '', // 异常跳页需要父子传参
      natures: this.$i18n.t('lang.NewspaperInfoList.complainFlaglist'), // 事件性质list
      patrolSearchText: '', // 巡检标准搜索关键字
      deviceSearchText: '', // 巡检设备搜索关键字
    }
  },
  props: ['showingPage'],
  components: {
		'upload-morefile': uploadmoreFile
	},
  computed: {
    ...mapGetters({ gardenId: 'gardenId', nickName: 'nickName' }),
    filteredPatrolStandards() {
      if (!this.patrolSearchText) {
        return this.patrolStandardList
      }
      return this.patrolStandardList.filter(item => 
        item.name.toLowerCase().includes(this.patrolSearchText.toLowerCase())
      )
    },
    filteredPatrolDevices() {
      if (!this.deviceSearchText) {
        return this.patrolDeviceList
      }
      return this.patrolDeviceList.filter(item => 
        item.name.toLowerCase().includes(this.deviceSearchText.toLowerCase())
      )
    }
  },
  created() {
	this.form.user = this.nickName
    if (this.$route.query.parentId) {
      this.parentId = this.$route.query.parentId
    }
    // 杜，新增1
    this.staffs(this.gardenId)
    if (this.showingPage === 'fourhundred') {
      console.log('我是从 400报事 进入的后台补单')
    } else if (this.showingPage === 'allMaintainQuartzJob') {
      console.log('我是从 全项目自动巡检报事 进入的后台补单')
      this.form.value = this.gardenId === 0 ? this.form.value = '' : this.form.value = this.gardenId 
      this.getPatrolStandard()
      this.getPatrolDevice()
    } else if (this.showingPage === 'allMaintain') {
      console.log('我是从 全项目报事信息 进入的后台补单')
      this.form.value = this.gardenId === 0 ? this.form.value = '' : this.form.value = this.gardenId 
      this.getPatrolStandard()
      this.getPatrolDevice()
    } else if (this.showingPage === 'maintainInfo') {
      console.log('我是从 报事信息 进入的后台补单')
      this.form.value = this.gardenId === 0 ? this.form.value = '' : this.form.value = this.gardenId 
      this.getPatrolStandard()
      this.getPatrolDevice()
    }
    // 小区下拉
    this.localGardens()
    if (this.showingPage != 'fourhundred') {
      // 获取楼号下拉候选
      this.gardenGrids(this.form.value)
    }
    // 一级别下拉
    this.maintainTypes()
    // 事件性质投诉表扬下拉
    this.getValueListByCode()
  },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      if (this.showingPage != 'fourhundred') {
        this.form.value = this.gardenId === 0 ? this.form.value = '' : this.form.value = this.gardenId 
        this.gardenGrids(this.form.value)
      }
    }
  },
  methods: {
      // 获取组件值
    getFile(e) {
      this.fileList.push({
        name: '',
        url: e
    })
    },
    // 移除图片
    removeFile(e) {
    let list1 = []
     for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].url === e) {

        } else {
          list1.push(this.fileList[i])
        }
     }
      this.fileList = list1
    },
    // 附件获取组件值
    getFilefj(e) {
       this.fileListfj.push({
        name: '',
        url: e
    })
    },
    // 移除附件
    removeFilefj(e) {
    let list2 = []
     for (let i = 0; i < this.fileListfj.length; i++) {
        if (this.fileListfj[i].url === e) {

        } else {
          list2.push(this.fileListfj[i])
        }
     }
      this.fileListfj = list2
    },
    // 巡检标准
    selectPatrolStandard() {
      this.isShow = true
      this.title = this.$i18n.t('lang.lab_inspectionStandardList')
    },
    // 巡检标准详情
    previewPatrolStandard(id) {
      this.getPatrolStandardById(id)
      this.isPreview = true
      this.titlePreview = this.$i18n.t('lang.lab_inspectionStandardPreview')
    },
    // 巡检设备
    selectPatrolDevice() {
      this.isShow = true
      this.title = this.$i18n.t('lang.lab_inspectionDeviceList')
    },
    // 巡检标准详情获取
    getPatrolStandardById(id) {
      this.$get(`patrolStandardById/` + id).then(
        res => {
          if (res && res.errCode === 0) {
            this.formPreview = res
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 巡检标准列表获取
    getPatrolStandard() {
      this.$get(
        `patrolStandard/?maintainType1=0&maintainType2=0&maintainType3=0&pageNo=1&pageSize=1500&gardenId=${this.gardenId}`
      ).then(
        res => {
          if (res && res.errCode === 0) {
            this.patrolStandardList = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 巡检设备列表获取
    getPatrolDevice() {
      this.$get(`device/?gardenId=${this.form.value}&pageNo=1&pageSize=999`).then(
        res => {
          if (res && res.errCode === 0) {
            this.patrolDeviceList = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 监听关闭dialog
    handleDialogClosed() {
      console.log('Dialog Closed', this.title)
    },
    keyBA() {
      // 仅保留数字和"."
      this.form.tele = this.form.tele.replace(/[^\d]/g, '')
      // 首位是0的话去掉
      if (this.form.tele.indexOf('.') < 0 && this.form.tele != '') {
        this.form.tele = parseFloat(this.form.tele)
      }
    },
    // 事件性质投诉表扬下拉
    getValueListByCode() {
      let loading = this.$loading()
      this.$get(`/getValueListByCode?code=complainType`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.group = res.result
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 小区下拉
    localGardens() {
      let myGardens = [...this.$store.getters.userGardenList]
      let index = myGardens.findIndex(item => item.id === 0)
      if (index != -1) {
        myGardens.splice(index, 1)
      }
      this.gardens = myGardens
    },
    // 报事服务分类list
    maintainTypes() {
      let loading = this.$loading()
      this.$get(
        `/maintainTypes?type=${this.typeleval}&pageSize=999&pageNo=1&parentId=${this.form.value}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            if (this.typeleval === 1) {
              this.firstLevellist = res.list
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 通过级别id查询下一级别list
    levalmaintainTypes(Pid) {
      this.$get(
        `/maintainTypes?type=${this.typeleval}&pageSize=999&pageNo=1&Pid=${Pid}`
      ).then(
        res => {
          if (res && res.errCode === 0) {
            if (this.typeleval === 2) {
              this.secondLevellist = res.list
            } else if (this.typeleval === 3) {
              this.thirdLevellist = res.list
            } else if (this.typeleval === 4) {
              this.fourthLevellist = res.list
            } else if (this.typeleval === 5) {
              this.fifthLevellist = res.list
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // id查询楼号楼层房间号
    gardenGrids(gardenid) {
      if (gardenid === '0' || gardenid === '') {
        return
      }
      this.$get(
        `/gardenGrids?type=${this.type}&pageSize=999&pageNo=1&parentId=${gardenid}`
      ).then(
        res => {
          if (res && res.errCode === 0) {
            if (this.type === 1) {
              this.floorList = res.list
            } else if (this.type === 2) {
              this.unitList = res.list
            } else if (this.type === 3) {
              this.roomList = res.list
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 通过小区选择楼号
    selectFloor(value) {
      this.type = 1
      this.form.floorid = ''
      this.form.unitid = ''
      this.form.roomid = ''
      this.unitList = []
      this.roomList = []
      this.floorList = []
      this.gardenGrids(this.form.value)
      this.staffs(this.form.value)
    },
    // 通过楼层选择单元号
    selectUnit(value) {
      this.type = 2
      this.unitList = []
      this.form.unitid = ''
      this.form.roomid = ''
      this.roomList = []
      this.gardenGrids(this.form.floorid)
    },
    // 通过单元选择房间号
    selectRoom(value) {
      this.roomList = []
      this.type = 3
      this.form.roomid = ''
      this.gardenGrids(this.form.unitid)
    },
    // 通过一级别查询二级下拉list
    selectSecond(value) {
      this.typeleval = 2
      this.levalmaintainTypes(this.form.firstLevelid)
      this.form.secondLevelid = ''
      this.form.thirdLevelid = ''
      this.thirdLevellist = []
      this.form.fourthLevelid = ''
      this.fourthLevellist = []
      this.form.fifthLevelid = ''
      this.fifthLevellist = []
    },
    // 通过二级别查询三级下拉list
    selectThird(value) {
      this.typeleval = 3
      this.levalmaintainTypes(this.form.secondLevelid)
      this.form.thirdLevelid = ''
      this.form.fourthLevelid = ''
      this.fourthLevellist = []
      this.form.fifthLevelid = ''
      this.fifthLevellist = []
    },
    // 通过三级别查询四级下拉list
    selectFourth(value) {
      this.typeleval = 4
      this.levalmaintainTypes(this.form.thirdLevelid)
      this.form.fourthLevelid = ''
      this.form.fifthLevelid = ''
      this.fifthLevellist = []
    },
    // 通过四级别查询五级下拉list
    selectFifth(value) {
      this.typeleval = 5
      this.levalmaintainTypes(this.form.fourthLevelid)
      this.form.fifthLevelid = ''
    },
    // 责任人抄送人下拉
    staffs(gardenIds) {
      let loading = this.$loading()
      this.$get(`/staffs?pageSize=999&pageNo=1&gardenId=${gardenIds}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.chargePersons = res.list
            this.copyPersons = res.list
            this.endPersons = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    jump() {
      if (this.showingPage === 'fourhundred') {
        this.$router.push({ name: '400NewspaperInfoList' })
      } else if (this.showingPage === 'allMaintain') {
        this.$router.push({ name: 'projectWideRepoInfoList' })
      } else if (this.showingPage === 'maintainInfo') {
        this.$router.push({ name: 'repoInfoList' })
      }
    },
    // 清空
    res(formName) {
      this.clears = true
      this.$refs.form.clearValidate()
      this.fileList = [] // 图片列表清空
      this.fileListfj = [] // 附件列表清空
      this.form.nature = ''
      this.form.context = ''
      this.form.user = ''
      this.form.tele = ''
      this.form.withFiles = ''
      this.form.files = ''
      this.form.value = ''
      this.form.floorid = ''
      this.form.unitid = ''
      this.form.roomid = ''
      this.form.secondLevelid = ''
      this.form.thirdLevelid = ''
      this.form.firstLevelid = ''
      this.form.fourthLevelid = ''
      this.form.fifthLevelid = ''
      this.form.chargePerson = ''
      this.form.endPerson = ''
      this.form.linkUrl = ''
      this.form.copyPerson = []
      this.form.isValet = ''
      this.form.remark = ''
      this.patrolStandard = []
      this.device = []
      setTimeout(() => {
        this.$refs[formName].clearValidate()
      }, 0)
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.id === '') {
            // 上传图片
            if (this.fileList.length > 0) {
              for (let i = 0; i < this.fileList.length; i++) {
                this.fileslist.push(this.fileList[i].url)
              }
            }
            // 上传附件
            if (this.fileListfj.length > 0) {
              for (let j = 0; j < this.fileListfj.length; j++) {
                this.withFileslist.push(this.fileListfj[j].url)
              }
            }
            let params = {
              parentId: this.parentId,
              gardenid: this.form.value,
              houseId: this.form.floorid,
              unitId: this.form.unitid,
              roomId: this.form.roomid,
              maintainTypeId1: this.form.firstLevelid,
              maintainTypeId2: this.form.secondLevelid,
              maintainTypeId3: this.form.thirdLevelid,
              maintainTypeId4: this.form.fourthLevelid,
              maintainTypeId5: this.form.fifthLevelid,
              mobile: this.form.tele,
              username: this.form.user,
              content: this.form.context,
              files: this.fileslist.toString(),
              withFiles: this.withFileslist.toString(),
              taskType: this.form.nature,
              sendSource: this.showingPage === 'fourhundred' ? 4 : 1,
              complainFlag2: 0,
              staff: this.form.chargePerson, // 责任人
              endPerson: this.form.endPerson, // 封单人
              linkUrl: this.form.linkUrl,
              complainType: this.form.searchUnit.toString(), // 类别
              copyToStaff: this.form.copyPerson.toString(), // 抄送人
              isValet: this.form.isValet, // 是否代客报事
              isRequireDigitalSignature: this.form.isRequireDigitalSignature, // 是否开启电子签名
              isThirdMaintain: this.form.isThirdMaintain,
              remark: this.form.remark, // 是否代客报事
              patrolStandard: this.patrolStandard.toString(), // 巡检设备
              device: this.device.toString() // 巡检设备
            }
            let loading = this.$loading()
            this.$post(`/maintains/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.jump()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.backgroundSupply {
  .trees {
   height: 600px;
   overflow-y: auto;
  }
  .trees::-webkit-scrollbar {
    width: 10px;
    height: 1px;
  }
  .trees::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: rgba(144, 147, 153, 0.3);
  }
  .el-form-item__content {
    width: 60vw !important;
  }
  .martop {
    margin-top: 20px;
    margin-left: 20px;
  }
  .checkbox-line {
    text-align: left;
    .el-checkbox,
    .el-checkbox-button__inner,
    .el-radio {
      width: 520px;
      // margin-left: 40px;
    }
  }
  .option-color {
    color: #606266;
  }
  .option-text {
    margin-bottom: 20px !important;
  }
  .el-scrollbar__bar {
    display: none;
  }
}
.img {
  width: 80px;
  height: 50px;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 5px;
}
</style>